const actions = {
  SET_AGENCY_STAFF: 'SET_AGENCY_STAFF',
  ADD_AGENCY_STAFF_USER: 'ADD_AGENCY_STAFF_USER',
  UPDATE_AGENCY_STAFF_USER: 'UPDATE_AGENCY_STAFF_USER',
  DELETE_AGENCY_STAFF_USER: 'DELETE_AGENCY_STAFF_USER',
};

export default actions;
